<template>
  <div class="milestones-content__wrapper">
    <div class="row">
      <div class="col-lg-4">
        <div class="milestones-content__img">
          <img :src="currentImage" alt="" class="transition-image" />
        </div>
      </div>
      <div class="col-lg-8" v-if="posts && posts.length">
        <div
          v-for="(post, i) in posts"
          :key="i"
          class="milestones-content__item"
          @mouseover="changeImage(post.image)"
        >
          <div class="milestones-content__group">
            <div class="milestones-content__remark text-yellow-ci">
              {{ post.excerpt }}
            </div>
            <div class="milestones-content__row">
              <div>
                <div class="milestones-content__year h3">
                  {{ post.title }}
                </div>
              </div>

              <!-- แสดง HTML post.body -->
              <div class="milestones-content__detail" v-html="post.body"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { ref, watch } from 'vue';
import { defineProps } from 'vue';

// รับ props
const props = defineProps({
  posts: {
    type: Array,
    default: () => []
  }
});

// กำหนด currentImage โดยเช็คว่ามีข้อมูลใน posts หรือไม่
const currentImage = ref(props.posts.length > 0 ? props.posts[0].image : "");

// เปลี่ยนรูปภาพเมื่อ hover
const changeImage = (newImage) => {
  currentImage.value = newImage;
};

// อัพเดต currentImage หาก posts เปลี่ยน
watch(() => props.posts, (newPosts) => {
  if (newPosts && newPosts.length > 0) {
    currentImage.value = newPosts[0].image;
  }
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";

@each $lang in $languages {
  html[lang="#{$lang}"] {
    .milestones-content {
      .milestones-content__year {
        line-height: 1.05;
      }
    }
  }
}

.milestones-content {
  .milestones-content__wrapper {
    margin: 3.75rem 0 0 0;
  }
  .milestones-content__item {
    padding: 30px 0 40px 20px;
    border-top: 1px solid $gray-1;
    @include transition();

    &:last-child {
      border-bottom: 1px solid $gray-1;
    }
    @include hover {
      .milestones-content__group {
        transform: translateX(-20px);
      }
    }
    @include media-breakpoint-down(md) {
      pointer-events: none;
    }
  }
  .milestones-content__row {
    display: flex;
    flex-direction: row;
    gap: 110px;
    @include media-breakpoint-down(md) {
      gap: 15px;
      flex-direction: column;
    }
  }
  .milestones-content__group {
    @include transition();
  }
  .milestones-content__year {
    transition: color 1s ease;
    color: $black;
  }
  .milestones-content__remark {
    text-wrap: nowrap;
  }
  .milestones-content__img {
    text-align: center;
    img {
      max-width: 90%;
      height: auto;
      object-fit: cover;
      border-radius: 20px;

      @include media-breakpoint-down(lg) {
        max-width: 100%;
        height: auto;
      }
    }
    @include media-breakpoint-down(md) {
      display: none;
    }
  }
}
</style>